import * as React from "react";
import { renderBetButtons } from "./renderBetButtons";
import { prepareEmptyMarket, pickLiveOrPreliveId } from "../../../../../helpers";
/* istanbul ignore next */
export var renderMarkets = function (cardProps, buttonsHolderClass, componentPrefix) {
    var marketsInConfig = cardProps.sport.config.markets;
    return (React.createElement("div", { key: componentPrefix + "__buttons-holder__" + cardProps.event.id, className: "rj-ev-list__" + componentPrefix + "__buttons-holder " + buttonsHolderClass, "data-uat": "div-ev-list-" + componentPrefix + "-buttons-holder" }, marketsInConfig.map(function (m, index) {
        var market = cardProps.markets.find(function (market) { return market.marketType.id === pickLiveOrPreliveId(m, cardProps.event.isLive); });
        var emptyMarket = prepareEmptyMarket(cardProps, m.template, index);
        return renderBetButtons(cardProps, market || emptyMarket, componentPrefix);
    })));
};
//# sourceMappingURL=renderMarkets.js.map